<template>
  <DropdownField
    inputId="payment-config-type"
    :name="fieldName"
    :label="translate(`${LOCALE_PREFIX}.form.type`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.typePlaceholder`)"
    :options="paymentConfigTypes"
    optionLabel="label"
    optionValue="value"
    :required="false"
    :disabled="!editPaymentInfo"
  />
</template>

<script setup lang="ts">
import { DropdownField } from '@centric-os/components/src/composed/validators/dropdown-field';
import { useTranslation } from '@centric-os/helpers';
import { usePaymentInfo } from '../../composables';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes/stores/use-financial-config-store';
import { computed } from 'vue';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_PAYMENT_INFO;

// Set payment config composable
const { paymentConfigTypes } = usePaymentInfo();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo, isStationInitialSetup } = storeToRefs(fConfigStore);

const fieldName = computed<string>(() => {
  if (isStationInitialSetup.value) {
    return 'paymentConfig.paymentSettings.type';
  }
  return 'type';
});
</script>
